import React from "react";
import {Box, Checkbox, Typography,} from "@mui/material";
import {getPerc} from "../svc/Utils";

export default function DpeScale2({scalecolor, text, dpe, nbDpesV2, changeState, title, chV1, chV2}) {
    const [state, setState] = React.useState({
        "A": true,
        "B": true,
        "C": true,
        "D": true,
        "E": true,
        "F": true,
        "G": true
    });

    function getWidth(props, dpeElement, nbDpesV2) {
        let max=0
        Object.keys(dpe).map((d) => {
            if(max <parseInt(dpe[d])){
                max=parseInt(dpe[d])
            }
        })
        return "calc(" + props + "px * " + (dpeElement) / (max) + ")";
    }

    if (dpe) {
        return (
            <Box sx={{width: "20%", ml: 1, mr: 1}}>
                <Box sx={{width: 250, display: "flex", height: 25, alignItems: "center",marginBottom:1}}>
                    <Typography sx={{width: 200, textAlign: "center",fontWeight :800}} variant="subtitle1">{title}</Typography>
                    {chV1}
                    {chV2}
                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>


                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.A,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.A}</Typography>
                    </Box>
                    <Box sx={{
                        width: 215,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(210, dpe["A"], nbDpesV2),
                            backgroundColor: scalecolor.A,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 215,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["A"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["A"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.B} onClick={() => {
                        let tmpState = {...state, B: !state.B};
                        setState(tmpState)
                        changeState(tmpState);

                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.B,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.B}</Typography>
                    </Box>
                    <Box sx={{
                        width: 215,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(210, dpe["B"], nbDpesV2),
                            backgroundColor: scalecolor.B,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 215,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["B"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["B"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>

                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.C} onClick={() => {
                        let tmpState = {...state, C: !state.C};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.C,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.C}</Typography>
                    </Box>
                    <Box sx={{
                        width: 215,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(210, dpe["C"], nbDpesV2),
                            backgroundColor: scalecolor.C,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 215,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["C"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["C"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.D} onClick={() => {
                        let tmpState = {...state, D: !state.D};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.D,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.D}</Typography>
                    </Box>
                    <Box sx={{
                        width: 215,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(210, dpe["D"], nbDpesV2),
                            backgroundColor: scalecolor.D,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 215,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["D"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["D"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.E} onClick={() => {
                        let tmpState = {...state, E: !state.E};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.E,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.E}</Typography>
                    </Box>
                    <Box sx={{
                        width: 215,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(210, dpe["E"], nbDpesV2),
                            backgroundColor: scalecolor.E,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 215,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["E"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["E"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>

                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.F} onClick={() => {
                        let tmpState = {...state, F: !state.F};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.F,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.F}</Typography>
                    </Box>
                    <Box sx={{
                        width: 215,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(210, dpe["F"], nbDpesV2),
                            backgroundColor: scalecolor.F,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 215,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["F"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["F"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>
                <Box sx={{
                    width: 250,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    {changeState && <Checkbox sx={{p: 0}} size="small" checked={state.G} onClick={() => {
                        let tmpState = {...state, G: !state.G};
                        setState(tmpState)
                        changeState(tmpState);
                    }}/>}
                    <Box sx={{
                        width: 30,
                        backgroundColor: scalecolor.G,
                        height: 20,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "100%", fontWeight: 'bold', pl: 1}}>
                            {text.G}</Typography>
                    </Box>
                    <Box sx={{
                        width: 215,
                        height: 20,

                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Box sx={{
                            width: getWidth(210, dpe["G"], nbDpesV2),
                            backgroundColor: scalecolor.G,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            height: 20,
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            zIndex: 99,
                            width: 215,
                            height: 20,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {dpe["G"]}
                            </Typography>
                            <Typography
                                sx={{
                                    width: "50%",
                                    pl: 1,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                {getPerc((dpe["G"]) / (nbDpesV2))}
                            </Typography>
                        </Box>
                    </Box>


                </Box>

            </Box>
        )
    }

}
